/*
 * BOGO changes merchandise quantities only. Shopify owns all discount prices,
 * inventory checks and checkout totals. cartEnabled stays false until the
 * matching native discounts have been configured and verified.
 */
(function (root, factory) {
  const helpers = factory();
  if (typeof module === 'object' && module.exports) module.exports = helpers;
  if (!root?.document || root.TiaraBogo?.prepareFormData) return;

  root.TiaraBogo = {
    prepareFormData: helpers.createPrepareFormData(() => {
      const source = root.document.getElementById('TiaraBogoConfig');
      if (!source || source.type !== 'application/json') return null;
      return JSON.parse(source.textContent);
    }),
  };
})(typeof window === 'undefined' ? null : window, function () {
  const ISO_WITH_ZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;

  function variantKey(value) {
    if (typeof value === 'number') {
      return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
    }
    return typeof value === 'string' && /^[1-9]\d*$/.test(value) ? value : null;
  }

  function offerQuantity(value) {
    if (value == null) return 1;
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) return null;
    const quantity = Number(value);
    return Number.isSafeInteger(quantity) && quantity > 0 && quantity <= Math.floor(Number.MAX_SAFE_INTEGER / 2)
      ? quantity
      : null;
  }

  function quantityForOffer(config, id, quantity, sellingPlan, now = Date.now()) {
    if (!config || config.active !== true || config.cartEnabled !== true) return null;
    // These are the current storefront market/currency, rendered by Liquid.
    if (config.currency !== 'EGP' || config.country !== 'EG') return null;
    if (sellingPlan != null && (typeof sellingPlan !== 'string' || sellingPlan.trim() !== '')) return null;
    if (typeof config.start !== 'string' || typeof config.end !== 'string'
      || !ISO_WITH_ZONE.test(config.start) || !ISO_WITH_ZONE.test(config.end)) return null;
    const start = Date.parse(config.start);
    const end = Date.parse(config.end);
    if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(now)
      || end < start || now < start || now > end) return null;
    if (!Array.isArray(config.variants) || config.variants.length === 0) return null;

    const eligibleIds = new Set();
    for (const variant of config.variants) {
      const key = variantKey(variant?.id);
      if (!key || eligibleIds.has(key) || typeof variant.handle !== 'string' || !variant.handle
        || !Number.isSafeInteger(variant.price) || variant.price <= 0) return null;
      eligibleIds.add(key);
    }
    const key = variantKey(id);
    const paidQuantity = offerQuantity(quantity);
    return key && eligibleIds.has(key) && paidQuantity !== null ? paidQuantity * 2 : null;
  }

  function createPrepareFormData(readConfig, clock = Date.now) {
    const prepared = new WeakSet();
    return function prepareFormData(formData) {
      try {
        if (!formData || typeof formData.getAll !== 'function' || typeof formData.set !== 'function'
          || typeof formData.keys !== 'function' || prepared.has(formData)) return false;
        // This helper handles one selected variant, never a bulk/cart-update form.
        if (formData.getAll('id').length !== 1 || formData.getAll('quantity').length > 1) return false;
        for (const key of formData.keys()) {
          if (/^items(?:\[|$)/.test(key)) return false;
        }
        const sellingPlans = formData.getAll('selling_plan');
        if (sellingPlans.some((value) => typeof value !== 'string' || value.trim() !== '')) return false;
        const quantity = quantityForOffer(readConfig(), formData.get('id'), formData.get('quantity'), null, clock());
        if (quantity === null) return false;

        formData.set('quantity', String(quantity));
        prepared.add(formData);
        return true;
      } catch (_) {
        // Missing/malformed configuration must preserve the ordinary cart path.
        return false;
      }
    };
  }

  return { quantityForOffer, createPrepareFormData };
});
